import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);
    const [navigation, setNavigation] = useState({ left: [], right: [] });
    const [loading, setLoading] = useState(true);

    const refresh = async () => {
        try {
            const [s, n] = await Promise.all([
                api.get('/settings'),
                api.get('/navigation'),
            ]);
            setSettings(s.data);
            setNavigation(n.data);
        } catch (e) {
            console.error('Failed to load site config', e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { refresh(); }, []);

    return (
        <SiteContext.Provider value={{ settings, navigation, loading, refresh, setSettings, setNavigation }}>
            {children}
        </SiteContext.Provider>
    );
};

export const useSite = () => {
    const ctx = useContext(SiteContext);
    if (!ctx) throw new Error('useSite must be used within SiteProvider');
    return ctx;
};
